/**
 * Which mobile code generator a configuration targets when Android and/or iOS is
 * published. `Native` is 0 so configurations saved before this setting existed
 * resolve to today's behaviour (Android Kotlin + iOS Swift projects).
 *
 * Mirrors `Kuika.Designtime.Model.Enums.EMobileGenerationType`.
 */
export enum EMobileGenerationType {
  Native = 0,
  ReactNative = 1
}
